import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    text: {
      textTransform: 'none',
      color: palette.primary.contrastText
    },
    startIcon: {
      fill: palette.primary.contrastText
    }
  };
});
var Container = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

var Item = function Item(_a) {
  var className = _a.className,
      children = _a.children,
      icon = _a.icon,
      rest = __rest(_a, ["className", "children", "icon"]);

  var classes = useStyles();
  return React.createElement(Container, {
    className: className
  }, React.createElement(Button, Object.assign({
    classes: {
      startIcon: classes.startIcon,
      text: classes.text
    },
    startIcon: icon
  }, rest), children));
};

Item.displayName = 'Footer.Item';
var ItemExtra = styled(Item)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export default ItemExtra;